// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feedback_btn__O2ajV {
  display: flex;
  justify-content: space-between;
  margin-top: 4rem;
}

.Feedback_rcb__5Vbe7 {
  margin-bottom: 4rem;
}

.Feedback_filterClass__yoLA8 {
  display: flex;
  justify-content: space-between;
  margin-top: 8rem;
}
@media only screen and (max-width: 25em) {
  .Feedback_filterClass__yoLA8 {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Feedback/Feedback.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AADD;AAGC;EALD;IAMC,sBAAA;EAAC;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.btn {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 4rem;\n}\n\n.rcb {\n    margin-bottom: 4rem;\n}\n\n.filterClass {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 8rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\tflex-direction: column;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Feedback_btn__O2ajV`,
	"rcb": `Feedback_rcb__5Vbe7`,
	"filterClass": `Feedback_filterClass__yoLA8`
};
export default ___CSS_LOADER_EXPORT___;
